import gql from 'graphql-tag'
import { ticketAlertFragment } from './getActiveTicketAlerts'

export const UPDATE_TICKET_ALERT = gql`
  mutation updateTicketAlert($input: UpdateTicketAlertInput!) {
    updateTicketAlert(input: $input) {
      ticketAlert {
        ...alert
      }
      errors {
        code
        message
      }
    }
  }
  ${ticketAlertFragment}
`
